import { Component, inject, signal } from "@angular/core";
import { NotificationService } from "@kno2/common/services/notifications";
import { AuthService } from "@kno2/core/auth";
import { SessionService } from "@kno2/core/session";
import { SupportService } from "@kno2/data-access/support";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-account-organization-reactivation-modal",
    imports: [DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./account-organization-reactivation-modal.component.html"
})
export class AccountOrganizationReactivationModalComponent {
    private readonly authService = inject(AuthService);
    private readonly sessionService = inject(SessionService);
    private readonly supportService = inject(SupportService);
    private readonly notificationService = inject(NotificationService);
    private readonly dialogService = inject(DialogService);

    protected readonly hasSubmitted = signal(false);

    protected async sendRequest(): Promise<void> {
        this.hasSubmitted.set(true);

        const profile = this.sessionService.profileData();
        if (!profile) return;

        const { fullName, userName: emailAddress, organizationName } = profile;

        try {
            await this.supportService.submitTicket({
                area: "Other",
                emailAddress,
                fullName,
                issueText: `Organization reactivation request for ${organizationName}`
            });

            this.notificationService.success("Your organization reactivation request has been submitted.");
            this.dialogService.close(true);
        } catch {
            this.hasSubmitted.set(false);
            this.notificationService.error("Failed to submit reactivation request. Please try again.");
        }
    }

    protected async cancel(): Promise<void> {
        const profile = this.sessionService.profileData();

        if (!profile?.orgIsCancelled && profile?.orgIsInGracePeriod) {
            this.dialogService.close();
            window.history.back();
        } else {
            this.dialogService.close();
            await this.authService.logout();
        }
    }
}
